module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [(_vm.extras.length > 0) ? _c('div', {
    staticClass: "row w-100"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)]) : _vm._e(), _vm._v(" "), (_vm.priceObj) ? _c('div', _vm._l((_vm.priceObj.productGenderPriceComponents), function(service, index) {
    return _c('div', {
      staticClass: "row w-100 mt-3"
    }, [_c('div', {
      staticClass: "col-sm-4"
    }, [(_vm.extras) ? _c('v-select', {
      attrs: {
        "options": _vm.extras,
        "placeholder": "- Select category -",
        "searchable": true,
        "label": "name"
      },
      on: {
        "input": function($event) {
          return _vm.updateExtra(service, service.component)
        }
      },
      model: {
        value: (service.component),
        callback: function($$v) {
          _vm.$set(service, "component", $$v)
        },
        expression: "service.component"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3"
    }, [(_vm.extras) ? _c('v-select', {
      attrs: {
        "options": service.component.prices,
        "placeholder": "- Select category -",
        "searchable": true,
        "label": "name"
      },
      on: {
        "input": function($event) {
          return _vm.updateExtraPrice(service, $event)
        }
      },
      model: {
        value: (service.component.selectedPrice),
        callback: function($$v) {
          _vm.$set(service.component, "selectedPrice", $$v)
        },
        expression: "service.component.selectedPrice"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2 pt-2"
    }, [(service.component.selectedPrice && service.component.selectedPrice.vatType !== undefined) ? _c('span', [_vm._v("\n                    " + _vm._s(_vm.taxIdToName(service.component.selectedPrice.vatType)) + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2 pt-2"
    }, [(service.component.selectedPrice) ? _c('span', [_vm._v("\n                    " + _vm._s(service.component.selectedPrice.grossprice) + " €\n                ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-1 pt-2"
    }, [_c('i', {
      staticClass: "ico-delete fs-large medium pointer m-0",
      on: {
        "click": function($event) {
          return _vm.removePrice(index)
        }
      }
    })])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.extras.length == 0) ? _c('div', {
    staticClass: "row d-flex justify-content-center text-center dark p-4"
  }, [_c('span', [_vm._v("✨ Looks like you have no services created, please create them "), _c('span', {
    staticClass: "bold underlined pointer",
    on: {
      "click": _vm.createExtraClick
    }
  }, [_vm._v("here")]), _vm._v(".")])]) : _c('div', {
    staticClass: "row mt-3 w-100"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "add d-flex align-items-center pointer fs-small bold",
    on: {
      "click": _vm.addRow
    }
  }, [_c('i', {
    staticClass: "ico-add fs-smallest add-circle color-1"
  }), _vm._v(" Add service\n            ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("Service")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("Price")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("Tax")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("PVP")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-1"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v(" ")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-11b2908b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11b2908b"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/products/SplitPriceEditor.vue
// module id = 949
// module chunks = 0